import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

type LpStatementBandProps = {
  eventName: string;
};

export default function LpStatementBand({ eventName }: LpStatementBandProps) {
  const ref = useRevealOnScroll<HTMLDivElement>();
  return (
    <section className="statement section-pad">
      <div ref={ref} className="wrap reveal">
        <p>
          {t('landingPage.v2.statement.textPre')}{' '}
          <span className="brandword">{eventName}</span>{' '}
          {t('landingPage.v2.statement.textPost')}
        </p>
        <p className="sub">{t('landingPage.v2.statement.sub')}</p>
      </div>
    </section>
  );
}
